export default "__VITE_ASSET__96af7916__"